import * as ReactRedux from 'react-redux';
import { AppState } from '../app/app.types';
import { push } from 'react-router-redux';
import { paths } from '../app/app.routes';
import PaymentListComponent from './PaymentListComponent';
import { getPayers, createPayer, updatePayer } from '../billing/billing.actions';
import { CountryCode, ProvinceCode } from '../geo/geo.types';
import {
  getMembers,
  createPayment,
  cancelMemberPayment,
  getMember,
  updateScheduledPayment,
  updatePayment
} from '../members/members.actions';
import { getPayMethods, createPayMethod, removePayMethod, getAllPayMethods } from '../billing/billing.actions';
import { Currency } from '../billing/billing.types';
import { getPaymentList, getPaymentDetails } from '../payments/Actions';

const mapDispatchToProps = (dispatch: Function) => {
  return {
    toDashboard: () => dispatch(push(paths.dashboard)),
    toAdminDashboard: () => dispatch(push(paths.adminDashboard)),
    getPayers: () => dispatch(getPayers()),
    createPayer: (
      businessId: number, firstName: string, lastName: string, initial: string,
      address: string, city: string, country: CountryCode | '', province: ProvinceCode | '',
      postalCode: string, mobile1: string, mobile2: string, email: string
    ) => dispatch(createPayer(
      businessId, firstName, lastName, initial, address, city, country, province, postalCode,
      mobile1, mobile2, email
    )),
    updatePayer: (
      businessId: number, id: number, firstName: string, lastName: string,
      initial: string, address: string, city: string, country: CountryCode | '', province: ProvinceCode | '',
      postalCode: string, mobile1: string, mobile2: string, email: string
    ) => dispatch(updatePayer(
      businessId, id, firstName, lastName, initial, address, city, country, province, postalCode,
      mobile1, mobile2, email
    )),
    getMembers: () => dispatch(getMembers()),
    getPayMethods: (payerId: number) => dispatch(getPayMethods(payerId)),
    getAllPayMethods: () => dispatch(getAllPayMethods()),
    createPayMethod: (
      payerId: number, paymentMethodType: string, accountHolderName: string,
      financialInstitutionName: string, transitNumber: string, financialInstitutionNumber: string,
      bankAccountNumber: string, cardHolderName: string, cardNumber: string, expiryMonth: string,
      expiryYear: string, cvc: string
    ) => dispatch(createPayMethod(
      payerId, paymentMethodType, accountHolderName,
      financialInstitutionName, transitNumber, financialInstitutionNumber, bankAccountNumber,
      cardHolderName, cardNumber, expiryMonth, expiryYear, cvc)
    ),
    removePayMethod: (paymentMethodId: number) => dispatch(removePayMethod(paymentMethodId)),
    createPayment: (
      id: number,
      paymentType: string,
      downPayment: number,
      total: number,
      amountPerTransaction: number,
      currency: Currency | '',
      term: string,
      numberOfTransactions: number,
      startDate: number,
      payerId: number,
      memberId: number,
      paymentMethodId: number,
      continuous: boolean,
      schedules: {
        scheduledPaymentId: number,
        chargeDate: number,
        amount: number,
        status: string
      }[],
      description?: string,
    ) => dispatch(createPayment(
      id,
      paymentType,
      downPayment,
      total,
      amountPerTransaction,
      currency,
      term,
      numberOfTransactions,
      startDate,
      payerId,
      memberId,
      paymentMethodId,
      continuous,
      schedules,
      description
    )),
    updatePayment: (
      id: number,
      payerId: number,
      paymentMethodId: number,
      continuous: boolean,
      amountPerTransaction: number,
      schedules: {
        scheduledPaymentId: number,
        chargeDate: number,
        amount: number,
        status: string
      }[],
      description?: string,
    ) => dispatch(updatePayment(
      id,
      payerId,
      paymentMethodId,
      continuous,
      amountPerTransaction,
      schedules,
      description
    )),
    cancelMemberPayment: (paymentId: number) => dispatch(cancelMemberPayment(paymentId)),
    getPaymentList: () => dispatch(getPaymentList()),
    getPaymentDetails: (paymentId: number) => dispatch(getPaymentDetails(paymentId)),
    getMember: (memberId: number) => dispatch(getMember(memberId)),
    updateScheduledPayment: (
      id: number,
      chargeDate: number,
      amount: number
    ) => dispatch(updateScheduledPayment(id, chargeDate, amount))
  };
};

const mapStateToProps = (state: AppState, ownProps) => {
  return {
    authState: state.authState,
    adminState: state.adminState,
    businessState: state.businessState,
    payersState: state.payersState,
    membersState: state.membersState,
    payMethodsState: state.payMethodsState,
    paymentsState: state.paymentsState
  };
};

const PaymentList = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(PaymentListComponent);

export default PaymentList;



// WEBPACK FOOTER //
// ./src/payments/PaymentList.tsx